module.exports = __webpack_public_path__ + "img/condition-item-plus-icon.634d0de9.svg";